import { render, staticRenderFns } from "./ECircularDescriptionView.vue?vue&type=template&id=7b205f46&scoped=true&"
import script from "./ECircularDescriptionView.vue?vue&type=script&lang=js&"
export * from "./ECircularDescriptionView.vue?vue&type=script&lang=js&"
import style0 from "./ECircularDescriptionView.vue?vue&type=style&index=0&id=7b205f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b205f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b205f46')) {
      api.createRecord('7b205f46', component.options)
    } else {
      api.reload('7b205f46', component.options)
    }
    module.hot.accept("./ECircularDescriptionView.vue?vue&type=template&id=7b205f46&scoped=true&", function () {
      api.rerender('7b205f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/eCircular/ECircularViews/ECircularDescriptionView.vue"
export default component.exports